import React from 'react';
import {
  Box,
  Typography
} from '@mui/material';
import {
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell
} from 'recharts';
import ResponsiveChart from './ResponsiveChart';

const CallReasonsChart = ({ data }) => {
  // Handle case where data might be the entire response object
  const processedData = Array.isArray(data) ? data : (data?.data || []);
  
  if (!processedData || processedData.length === 0) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        height={300}
        flexDirection="column"
      >
        <Typography variant="body2" color="text.secondary" gutterBottom>
          No data available
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Call reasons will appear here once you have call data
        </Typography>
      </Box>
    );
  }

  // Format data for chart
  const chartData = processedData.map(item => ({
    reason: item.category || 'Unknown',
    count: item.count || 0,
    percentage: item.percentage || 0
  }));

  // Colors for different reasons
  const COLORS = [
    '#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8',
    '#82CA9D', '#FFC658', '#FF6B6B', '#4ECDC4', '#45B7D1'
  ];


  const CustomPieTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0];
      return (
        <Box
          sx={{
            backgroundColor: 'background.paper',
            border: 1,
            borderColor: 'divider',
            borderRadius: 1,
            p: 2,
            boxShadow: 2
          }}
        >
          <Typography variant="body2" fontWeight="bold" gutterBottom>
            {data.name}
          </Typography>
          <Typography variant="body2" sx={{ color: data.color }}>
            Count: {data.value}
          </Typography>
          <Typography variant="body2" sx={{ color: data.color }}>
            Percentage: {data.payload.percentage}%
          </Typography>
        </Box>
      );
    }
    return null;
  };

  // Calculate percentages
  const totalCount = chartData.reduce((sum, item) => sum + item.count, 0);
  const dataWithPercentages = chartData.map(item => ({
    ...item,
    percentage: totalCount > 0 ? Math.round((item.count / totalCount) * 100) : 0
  }));

  return (
    <ResponsiveChart height={350} mobileHeight={250}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={dataWithPercentages}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, percentage }) => `${name}: ${percentage}%`}
            outerRadius={80}
            fill="#8884d8"
            dataKey="count"
          >
            {dataWithPercentages.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip content={<CustomPieTooltip />} />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </ResponsiveChart>
  );
};

export default CallReasonsChart; 